//
// Copyright © 2026 PlayJoy Studios.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//

import { AccountRole, roleOrder } from '@hcengineering/core'

/**
 * @public
 *
 * The verdict itself, apart from where the two answers come from: the interface reads them from
 * the model of the browser client, the service from the client of the same person.
 */
export function decideAccess (role: AccountRole | undefined, hasPermission: boolean): boolean {
  if (role !== undefined && roleOrder[role] >= roleOrder[AccountRole.Owner]) {
    return true
  }
  return hasPermission
}
